import { Injectable } from '@angular/core'


@Injectable()
export class PageHelper {

  private static lookupLocal: any = {

    'login': {
      routerLink: '/login',
    },

    'logout': {
      routerLink: '/logout',
    },

    'admin': {
      routerLink: '/admin',
    },

    'users': {
      routerLink: '/admin/users',
    },

    'orders': {
      routerLink: '/admin/orders'
    },

    'payments': {
      routerLink: '/admin/payments'
    },

    'services': {
      routerLink: '/admin/services'
    },

    'core': {
      routerLink: '/admin/overview',
    },

    'messages': {
      routerLink: '/admin/messages',
    },

  }

  public getLookup(val?) {
    return val ? PageHelper.lookupLocal[val] : PageHelper.lookupLocal
  }

  public lookupUrl(val) {
    return this.lookup(val, 'url')
  }

  public lookupRouterLink(val) {
    return this.lookup(val, 'routerLink')
  }

  public lookup(val, field?) {
    let lookup = this.getLookup(val)
    if (!field) return lookup
    return lookup && lookup[field]
  }

}
